import {ExperimentNames, getInputControlMeta} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import React, {useEffect, useState} from 'react'
import {Error} from '../../commons/error'
import {Label} from '../../commons/label'
import {Select} from '../../commons/select'
import fs from '../../fields.scss'
import {DropdownProps} from './interfaces'

export const Dropdown = ({input, control, meta: {dirty, touched, error}, t}: DropdownProps) => {
  const {experiments} = useExperiments()
  const [selectedValue, setSelectedValue] = useState(null)

  const persistSingleChoiceMandatoryViewerEnabled = experiments.enabled(
    ExperimentNames.PersistSingleChoiceMandatoryViewer,
  )
  const options: string[] = getInputControlMeta(control).options
  const {label, mandatory} = getInputControlMeta(control)

  const onChange = (selectedOption: string) => {
    input.onChange(selectedOption)
    setSelectedValue(selectedOption)
  }

  useEffect(() => {
    if (!selectedValue) {
      if (input.value) {
        onChange(input.value)
      } else if (!persistSingleChoiceMandatoryViewerEnabled && options.length) {
        onChange(options[0])
      }
    }
  }, [])

  return (
    <div className={fs.field}>
      <Label
        classes={fs.customCaption}
        dataHook="dropdown-caption"
        required={persistSingleChoiceMandatoryViewerEnabled ? mandatory : false}
        caption={label}
      />
      <Select
        options={options}
        value={selectedValue}
        ariaLabel={label}
        onChange={onChange}
        noDefaultValue={persistSingleChoiceMandatoryViewerEnabled}
      />
      <Error error={(dirty || touched) && error && t(error)} />
    </div>
  )
}
